import { IProjectBuilder, IProjectBuilderOptions } from '../types';

import { createProjectBuilder } from '../generator/ProjectBuilder';

import esmodule from '../plugins/common/esmodule';
import styleImport from '../plugins/common/styleImport';
import containerClass from '../plugins/component/react/containerClass';
import containerInitState from '../plugins/component/react/containerInitState';
import containerInjectContext from '../plugins/component/react/containerInjectContext';
import containerInjectUtils from '../plugins/component/react/containerInjectUtils';
import containerInjectDataSourceEngine from '../plugins/component/react/containerInjectDataSourceEngine';
import containerInjectConstants from '../plugins/component/react/containerInjectConstants';
import containerInjectI18n from '../plugins/component/react/containerInjectI18n';
import containerLifeCycle from '../plugins/component/react/containerLifeCycle';
import containerMethod from '../plugins/component/react/containerMethod';
import jsx from '../plugins/component/react/jsx';
import reactCommonDeps from '../plugins/component/react/reactCommonDeps';
import css from '../plugins/component/style/css';
import constants from '../plugins/project/constants';
import i18n from '../plugins/project/i18n';
import utils from '../plugins/project/utils';

import gant from '../plugins/project/framework/gant';

import { prettier } from '../postprocessor';
import containerFunction from '../plugins/component/react/containerFunction';
import containerState from '../plugins/component/react/containerState';
import containerStatement from '../plugins/component/react/containerStatement';
import functionJsx from '../plugins/component/react/functionJsx';

export type GantProjectBuilderOptions = IProjectBuilderOptions;

export default function createGantChunkProjectBuilder(
  options?: GantProjectBuilderOptions,
): IProjectBuilder {
  return createProjectBuilder({
    mode: options?.mode,
    inStrictMode: options?.inStrictMode,
    rootPaths: options?.rootPaths,
    pagePaths: options?.pagePaths,
    configPaths: options?.configPaths,
    extraContextData: { ...options },
    template: gant.template,
    plugins: {
      components: [
        reactCommonDeps(),
        esmodule({
          fileType: 'tsx',
        }),
        containerInjectUtils(),
        styleImport(),
        containerFunction(),
        containerState(),
        containerStatement(),
        functionJsx({
          nodeTypeMapping: {
            Div: 'div',
            Component: 'div',
            Page: 'Fragment',
            Block: 'div',
          },
          // Fragment属性过滤：只保留 key属性
          fragmentAttrFilter: true,
        }),
        css(),
      ],
      pages: [
        reactCommonDeps(),
        esmodule({
          fileType: 'tsx',
        }),
        containerInjectUtils({ scope: 'pages' }),
        styleImport(),
        containerFunction(),
        containerState(),
        containerStatement(),
        functionJsx({
          nodeTypeMapping: {
            Div: 'div',
            Component: 'Fragment',
            Page: 'Fragment',
            Block: 'Fragment',
            // Box: 'div',
          },
          // Fragment属性过滤：只保留 key属性
          fragmentAttrFilter: true,
        }),
        css(),
      ],
      router: [esmodule(), gant.plugins.router()],
      entry: [gant.plugins.entry()],
      constants: [constants()],
      utils: [esmodule(), utils('react')],
      i18n: [i18n()],
      globalStyle: [gant.plugins.globalStyle()],
      packageJSON: [gant.plugins.packageJSON()],
      config: [gant.plugins.config()],
      detailsMap: [gant.plugins.detailsMap()],
    },
    postProcessors: [prettier()],
    customizeBuilderOptions: options?.customizeBuilderOptions,
  });
}

export const plugins = {
  containerClass,
  containerInjectContext,
  containerInjectUtils,
  containerInjectDataSourceEngine,
  containerInjectI18n,
  containerInjectConstants,
  containerInitState,
  containerLifeCycle,
  containerMethod,
  jsx,
  commonDeps: reactCommonDeps,

  /** @deprecated Please use commonDeps */
  reactCommonDeps,
};
